import {Component} from '@angular/core';
import {Path} from '../../../../../path';
import {KnowledgeBaseTab} from '../../../knowledge-base.component';

@Component({
    selector: 'af-archive',
    standalone: false,
    templateUrl: './knowledge-base-archive.component.html',
})
export class KnowledgeBaseArchiveComponent {
    tabPathToTab: Record<string, KnowledgeBaseTab> = {[Path.DOCUMENTS]: 'tabDocuments'};
}
